import { Button } from '@journ/ui/button'
import { useIntlayer } from 'react-intlayer'
import { openSheet } from '@/features/ui/store'
import { useMemberParams } from './use-member-params'
import { GLOBAL_SHEET_IDS } from '@/features/ui/hooks/use-sheet'

const EmptyState = () => {
	const content = useIntlayer('hr-page')

	return (
		<div className='flex flex-col items-center justify-center py-24 space-y-4 text-center'>
			<p className='text-base font-medium'>{content.empty.title}</p>
			<p className='text-sm text-muted-foreground max-w-xs'>{content.empty.description}</p>
			<Button size='sm' onClick={() => openSheet(GLOBAL_SHEET_IDS.MEMBER_CREATE)}>
				{content.empty.action}
			</Button>
		</div>
	)
}

const NoResults = () => {
	const content = useIntlayer('hr-page')
	const { setParams } = useMemberParams()

	return (
		<div className='flex flex-col items-center justify-center py-24 space-y-4 text-center'>
			<p className='text-base font-medium'>{content.noResults.title}</p>
			<p className='text-sm text-muted-foreground'>{content.noResults.description}</p>
			<Button variant='outline' size='sm' onClick={() => setParams({ q: null })}>
				{content.noResults.action}
			</Button>
		</div>
	)
}

export { EmptyState, NoResults }
